import { render, staticRenderFns } from "./BenefitGroupCard.vue?vue&type=template&id=eb10ad0e&scoped=true"
import script from "./BenefitGroupCard.vue?vue&type=script&lang=js"
export * from "./BenefitGroupCard.vue?vue&type=script&lang=js"
import style0 from "./BenefitGroupCard.vue?vue&type=style&index=0&id=eb10ad0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb10ad0e",
  null
  
)

export default component.exports